import http from '@root/utils/axios/admin';

let state = {
    SubscribersList: [],
    Subscriber: {
        data: {},
        error: {}
    }
}

let actions = {

    fetchSubscribersList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('/user/subscribers', { params: filter }).then((response) => {
                commit('setSubscribers', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    fetchSubscriber({ commit }, id) {
        return new Promise((resolve, reject) => {
            http.get('/api/subscribers/' + id).then((response) => {
                commit('setSubscriber', response.data.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },
    deleteSubscriber({ commit }, id) {
        return http.delete('user/subscribers/' + id);
    },




}


let mutations = {
    setSubscribers(state, data) {
        state.SubscribersList = data;
    },
    setSubscriber(state, data) {
        state.Subscriber.data = data;
    },
    setSubscriberError(state, error) {

        state.Subscriber.error = error.errors;
    },
    cleanSubscriberError(state, error) {
        state.Subscriber.error = {};
    },

}

export default {
    state,
    actions,
    mutations
}